import React from "react";

export const DuplicateIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
      <path
        stroke="#113357"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.2"
        d="M6.89 8.815a1.926 1.926 0 0 1 1.925-1.926h6.26A1.926 1.926 0 0 1 17 8.815v6.259A1.926 1.926 0 0 1 15.074 17H8.815a1.926 1.926 0 0 1-1.926-1.926z"
      ></path>
      <path
        stroke="#113357"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.2"
        d="M4.73 13.921A1.45 1.45 0 0 1 4 12.667V5.444C4 4.65 4.65 4 5.444 4h7.223c.541 0 .836.278 1.083.722"
      ></path>
    </svg>
  );
};
